import { render } from "./ChatIcon.vue?vue&type=template&id=56179a16&scoped=true"
import script from "./ChatIcon.vue?vue&type=script&lang=js"
export * from "./ChatIcon.vue?vue&type=script&lang=js"

import "./ChatIcon.vue?vue&type=style&index=0&id=56179a16&lang=scss"
import "./ChatIcon.vue?vue&type=style&index=1&id=56179a16&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56179a16"]])

export default __exports__